@if (pageSignalStore.loading()) {
  <div class="spinner-container" (click)="$event.preventDefault();$event.stopPropagation()">
    <div class="spinner-border" role="status">
    </div>
  </div>
}
